import classnames from 'classnames';
import React, { CSSProperties, ReactNode } from 'react';

interface TableProps {
	children: ReactNode;
	className?: string;
	fullWidth?: boolean;
	style?: CSSProperties | null;
}

const Table: React.FC<TableProps> = ({ children, className = '', fullWidth = true, style = null }) => {
	const classes = {
		base: 'text-lg text-white',
		fullWidth: {
			true: 'w-full',
			false: '',
		},
	};

	return (
		<div className={classnames(classes.base, classes.fullWidth[fullWidth.toString()], className)} style={style}>
			{children}
		</div>
	);
};

export default Table;
